import React from "react";
import { Link } from "react-router-dom";
import NewsSidebar from "./Sidebar";
// Import BigImg
import BigImg from "../../assets/img/causes/details-big.png";
import causesImg from "../../assets/img/causes/details-small-1.png";
import causesImg1 from "../../assets/img/causes/details-small-2.png";
import PdfIcon from "../../assets/img/icon/pdf.png";
import PostImg from "../../assets/img/common/post-1.png";
import PostImg1 from "../../assets/img/common/post-2.png";
const NewsDetailsArea = () => {
  return (
    <>
      <section id="news_details_main" className="section_padding">
        <div className="container">
          <div className="row" id="counter">
            <div className="row" id="counter">
              <div className="col-lg-8">
                <div className="details_wrapper_area">
                  <div className="details_big_img">
                    <img src={BigImg} alt="img" />
                    <span className="causes_badge bg-yellow">Badminton &amp; community</span>
                  </div>
                  <div className="details_text_wrapper">
                    <h2>New badminton ladder and integration evening announced</h2>
                    <p>
                      PCF’s <strong>main sport is badminton</strong>—year-round hall sessions for juniors and adults, with a refreshed
                      ladder and fair rotation so everyone gets games. We are pairing the sports calendar with an{' '}
                      <strong>integration evening</strong> for parents on how to balance busy weeknights between homework, clubs, and
                      Swedish school expectations.
                    </p>
                    <p>
                      Seasonal programmes still matter: we will publish dates for <strong>swimming</strong> blocks, outdoor{' '}
                      <strong>cricket</strong> tasters, and <strong>football</strong> friendlies as venues open up—but the shuttle stays at the heart
                      of our weekly rhythm.
                    </p>
                    <h3>Sport and society together</h3>
                    <p>
                      Court time builds fitness and friendships; integration sessions build confidence navigating everyday
                      Sweden. Many families do both—while young people train on court, parents grab coffee and ask practical questions
                      in a judgment-free room.
                    </p>
                    <ul>
                      <li>
                        <i className="fas fa-circle"></i> Junior and adult badminton tracks with volunteer coaches.
                      </li>
                      <li>
                        <i className="fas fa-circle"></i> Racket bank and shoe guidance for newcomers.
                      </li>
                      <li>
                        <i className="fas fa-circle"></i> Seasonal swim, cricket, football sign-ups announced in the same newsletter.
                      </li>
                      <li>
                        <i className="fas fa-circle"></i> Social gatherings after selected integration talks—keep the conversation going.
                      </li>
                    </ul>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="details_small_img">
                          <img src={causesImg} alt="img" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="details_small_img">
                          <img src={causesImg1} alt="img" />
                        </div>
                      </div>
                    </div>
                    <p>
                      Email info@pcfsweden.se with your name, city, and whether you need junior or adult badminton—and if
                      you’d like to hear about the next integration evening.
                    </p>
                  </div>
                  <div className="download_pdf_area">
                    <div className="pdf_download_left">
                      <img src={PdfIcon} alt="icon" />
                      <h4>Badminton &amp; season planner (PDF)</h4>
                    </div>
                    <div className="pdf_download_right">
                      <Link to="#!" className="btn btn_md btn_theme">
                        Download now
                      </Link>
                    </div>
                  </div>
                  <div className="comment_area_details">
                    <h3>Community notes</h3>
                    <div className="post_comment_wrapper">
                      <div className="post_comment_item">
                        <div className="post_comment_img">
                          <img src={PostImg} alt="img" />
                        </div>
                        <div className="post_comment_text">
                          <div className="post_names_replay">
                            <h5>Hina A.</h5>
                            <a href="#!">
                              <i className="fas fa-reply"></i>Reply
                            </a>
                          </div>
                          <p>
                            Our whole family now plays badminton—integration talks helped me understand school letters too.
                          </p>
                        </div>
                      </div>
                      <div className="post_comment_item">
                        <div className="post_comment_img">
                          <img src={PostImg1} alt="img" />
                        </div>
                        <div className="post_comment_text">
                          <div className="post_names_replay">
                            <h5>Vikram P.</h5>
                            <a href="#!">
                              <i className="fas fa-reply"></i>Reply
                            </a>
                          </div>
                          <p>
                            Will there be beginner adult sessions? I’d like to volley after the integration talk.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="comment_form_area">
                    <h3>Leave a comment</h3>
                    <div className="comment_form">
                      <form action="#!" id="comment_form">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter full name"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter email address"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <textarea
                                rows="5"
                                placeholder="Write your comments"
                                className="form-control"
                                required
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="submit_btn">
                              <button className="btn btn_theme btn_md">
                                Submit comment
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <NewsSidebar />
            </div>
            <div className="col-lg-4"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsDetailsArea;
